import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import MuiLink from '@mui/material/Link';

// Otis Kit PRO components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import MKButton from 'components/MKButton';

function CenteredBlogCard({ image, title, description, action }) {
  const isImageString = typeof image === 'string';

  return (
    <Card>
      <MKBox position="relative" borderRadius="lg" mx={2} mt={-3} sx={{ overflow: 'hidden' }}>
        {isImageString ? (
          <>
            <MKBox
              component="img"
              src={image}
              alt={title}
              borderRadius="lg"
              width="100%"
              position="relative"
              zIndex={1}
            />
            <MKBox
              borderRadius="lg"
              shadow="md"
              width="100%"
              height="100%"
              position="absolute"
              left={0}
              top={0}
              sx={{
                backgroundImage: `url(${image})`,
                transform: 'scale(0.94)',
                filter: 'blur(12px)',
                backgroundSize: 'cover',
              }}
            />
          </>
        ) : (
          <MKBox width="100%" height="100%" borderRadius="lg" zIndex={1}>
            {image}
          </MKBox>
        )}
      </MKBox>

      <MKBox p={3} mt={-1} textAlign="center">
        <MKTypography display="inline" variant="h5" textTransform="capitalize" fontWeight="regular">
          {title}
        </MKTypography>
        <MKBox mt={1} mb={3}>
          <MKTypography variant="body2" component="p" color="text">
            {description}
          </MKTypography>
        </MKBox>

        {/* Puedes descomentar esto si quieres mostrar el botón de acción */}
        {/* {action.type === "external" ? (
          <MKButton
            component={MuiLink}
            href={action.route}
            target="_blank"
            rel="noreferrer"
            variant="gradient"
            size="small"
            color={action.color || "dark"}
          >
            {action.label}
          </MKButton>
        ) : (
          <MKButton
            component={Link}
            to={action.route}
            variant="gradient"
            size="small"
            color={action.color || "dark"}
            target="_blank"
          >
            {action.label}
          </MKButton>
        )} */}
      </MKBox>
    </Card>
  );
}

// Typechecking props for the CenteredBlogCard
CenteredBlogCard.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.shape({
    type: PropTypes.oneOf(['external', 'internal']),
    route: PropTypes.string,
    color: PropTypes.oneOf([
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'error',
      'dark',
      'light',
    ]),
    label: PropTypes.string,
  }),
};

export default CenteredBlogCard;
